import { Card, Typography, Form, Input, InputNumber, Select, DatePicker, Button, Row, Col, Flex, Space, Tag, Divider, Switch, Upload, message, Popconfirm } from 'antd'
import React, { useEffect, useState } from 'react'
import {
  ArrowLeftOutlined, UserOutlined, FileTextOutlined, CalendarOutlined,
  TeamOutlined, WalletOutlined, SettingOutlined, PaperClipOutlined,
  InboxOutlined, DeleteOutlined,
} from "@ant-design/icons"
import { QuotationService } from '../../../Services/Manage/QuotationService'
import { InvoiceService } from '../../../Services/Manage/InvoiceService'
import { UserService } from '../../../Services/Manage/UserService'
import { DepartmentEmpServices } from '../../../Services/Manage/DepartmentEmpServices'
import { ProjectService } from '../../../Services/Manage/ProjectService'
import { ConfigurationService } from '../../../Services/Manage/ConfigurationService'
import { ServicetypeService } from '../../../Services/Manage/ServicetypeService'
import { ENDPOINT } from '../../../Services/ENDPOINT'
import useMessage from 'antd/es/message/useMessage'
import { useLocation, useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'

const { TextArea } = Input
const { Option, OptGroup } = Select;
const { Title } = Typography;

const compactFormStyle = `
  .ant-form-item { margin-bottom: 15px !important; }
  .ant-card-body { padding: 16px 16px !important; }
  .ant-card { margin-bottom: 16px !important; }
  .ant-form-item-label { padding-bottom: 2px !important; }
  .ant-form-item-label > label { height: 20px !important; }
`;

const CardTitle = ({ icon, no, text }) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      color: "rgba(14, 93, 146, 0.95)",
    }}
  >
    {icon}
    <span style={{ fontWeight: 600 }}>{no}. {text}</span>
  </span>
);

// const projectTypeOptions = [
//   { value: "New Development", label: "New Development" },
//   { value: "Maintenance", label: "Maintenance" },
//   { value: "Support", label: "Support" },
//   { value: "Consulting", label: "Consulting" },
//   { value: "Custom", label: "Custom" },
// ];

const priorityOptions = [
  { value: "Low", label: "Low" },
  { value: "Medium", label: "Medium" },
  { value: "High", label: "High" },
  { value: "Urgent", label: "Urgent" },
];

const statusOptions = [

  { value: "Live", label: "Live" },
  { value: "Hold", label: "Hold" },
  { value: "Pending", label: "Pending" },
  { value: "Archive", label: "Archive" },
  { value: "Completed", label: "Completed" },
];

const paymentTypeOptions = [
  { value: "Milestone Based", label: "Milestone Based" },
  { value: "Fixed", label: "Fixed" },
  { value: "Hourly", label: "Hourly" },
];

const visibilityOptions = [
  { value: "Private", label: "Private" },
  { value: "Team", label: "Team" },
  { value: "Public", label: "Public" },
];

const currencyOptions = [
  { value: "INR", label: "INR - Indian Rupee" },
  { value: "USD", label: "USD - US Dollar" },
  { value: "EUR", label: "EUR - Euro" },
  { value: "GBP", label: "GBP - British Pound" },
];

const CreateProjects = () => {
  const [messageApi, msgContext] = useMessage();
  const [form] = Form.useForm();
  const [activeQuotation, setActiveQuotation] = useState([]);
  const [directInvoices, setDirectInvoices] = useState([]);
  const [departmentOption, setDepartmentOption] = useState([]);

  const [projectTypeOptions, setProjectTypeOptions] = useState([]);

  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [newCurrency, setNewCurrency] = useState('');
  const [addingCurrency, setAddingCurrency] = useState(false);

  const [userList, setUserList] = useState([]);
  const [managerOption, setManagerOption] = useState([]);

  const [allManagers, setAllManagers] = useState([]);

  const [engineerOption, setEnginerOption] = useState([]);
  const [editProject, setEditProject] = useState(null);
  const [projectId, generateProjectId] = useState('001');
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [pendingFiles, setPendingFiles] = useState([]);



  const [projectStatusOptions, setProjectStatusOptions] = useState([]);

  const location = useLocation();
  const navigate = useNavigate();
  const id = location.state?.id;
  const action = location.state?.action;
  const enableEdit = location.state?.enableEdit;

  

  const source = Form.useWatch('pro_source', form);
  const startDate = Form.useWatch('pro_start_date', form);
  const endDate = Form.useWatch('pro_target_end_date', form);
  const totalBudget = Form.useWatch('pro_total_budget', form);
  const downPaymentPercent = Form.useWatch('pro_down_payment_percent', form);
  

  const durationDays = (startDate && endDate)
    ? Math.max(dayjs(endDate).diff(dayjs(startDate), 'day'), 0)
    : 0;

  useEffect(() => {
    const amount = ((Number(totalBudget) || 0) * (Number(downPaymentPercent) || 0)) / 100;
    form.setFieldsValue({ pro_down_payment_amount: amount });
  }, [totalBudget, downPaymentPercent]);

  useEffect(() => {
    if (id) {
      getAllUser().then((activeUsers) => getProjectDataByID(id, activeUsers));
    }
  }, [id])

  const getProjectDataByID = async (id, activeUsers = allManagers) => {
    try {
      const request = await ProjectService.getAllProjectById(id);
      const initialValues = request.data;
      setEditProject(initialValues);

      let proEngineer = initialValues.pro_engineer;
      if (typeof proEngineer === 'string') {
        try { proEngineer = JSON.parse(proEngineer); } catch { proEngineer = []; }
      }

      let proTags = initialValues.pro_tags;
      if (typeof proTags === 'string') {
        try { proTags = JSON.parse(proTags); } catch { proTags = []; }
      }

      let proAttachments = initialValues.pro_attachments;
      if (typeof proAttachments === 'string') {
        try { proAttachments = JSON.parse(proAttachments); } catch { proAttachments = []; }
      }
      setFileList((proAttachments || []).map((f, idx) => ({
        uid: `existing-${idx}`,
        name: f.filename || f.name,
        status: 'done',
        url: f.path?.startsWith('http') ? f.path : `${ENDPOINT.base}/${f.path}`,
        response: { file: f },
      })));

      setSelectedDepartment(initialValues.pro_department);
      handleGetEnginer(initialValues.pro_department, activeUsers);

      form.setFieldsValue({
        ...initialValues,
        pro_department: String(initialValues.pro_department),
        pro_engineer: proEngineer,
        pro_tags: proTags || [],
        pro_start_date: initialValues?.pro_start_date ? dayjs(initialValues.pro_start_date, 'DD-MM-YYYY') : null,
        pro_target_end_date: initialValues?.pro_target_end_date ? dayjs(initialValues.pro_target_end_date, 'DD-MM-YYYY') : null,
        pro_target_completion_date: initialValues?.pro_target_completion_date ? dayjs(initialValues.pro_target_completion_date) : null,
      });
    } catch (error) {
      console.error(error);
    }
  };

  const onFinish = async (values) => {
    try {
      const user = await UserService.getOmeUser();

      // Upload any newly selected (not-yet-uploaded) files now, at Save time.
      let uploadedFiles = [];
      if (pendingFiles.length > 0) {
        for (const pf of pendingFiles) {
          try {
            const formData = new FormData();
            formData.append("file", pf.originFileObj);
            const res = await fetch(`${ENDPOINT.Project}/upload-file`, {
              method: "POST",
              body: formData,
            });
            const result = await res.json();
            if (result.status && result.success) {
              uploadedFiles.push(result.file);
            }
          } catch (e) {
            console.error("Attachment upload failed:", e);
          }
        }
      }

      // Existing (already-saved, edit mode) attachments still carry a `.file` in response
      const existingAttachments = fileList
        .filter((f) => !f.__pending)
        .map((f) => f.response?.file)
        .filter(Boolean);

      const attachments = [...existingAttachments, ...uploadedFiles];

      const payload = {
        ...values,
        pro_no: editProject ? editProject.pro_no : projectId,
        pro_engineer: JSON.stringify(values.pro_engineer || []),
        pro_tags: JSON.stringify(values.pro_tags || []),
        pro_attachments: JSON.stringify(attachments),
        pro_start_date: values.pro_start_date ? dayjs(values.pro_start_date).format('DD-MM-YYYY') : null,
        pro_target_end_date: values.pro_target_end_date ? dayjs(values.pro_target_end_date).format('DD-MM-YYYY') : null,
        pro_target_completion_date: values.pro_target_completion_date ? dayjs(values.pro_target_completion_date).format('YYYY-MM-DD') : null,
        ...(editProject ? {} : { added_by: user.uid }),
      };

      let request;
      if (editProject) {
        request = await ProjectService.updateProject(payload, id);
      } else {
        request = await ProjectService.createProject(payload);
      }

      if (request?.status) {
        messageApi.success(request.message);

        if (values.pro_source === 'Quotation' && values.qu_no) {
          try {
            await QuotationService.patchQuotation(values.qu_no, { project_created: true });
          } catch (e) {
            console.error(e);
          }
        }

        if (values.pro_source === 'Direct Invoice' && values.qu_no) {
          try {
            await InvoiceService.updateInvoiceByNo(values.qu_no, { project_created: true });
          } catch (e) {
            console.error(e);
          }
        }

        if (!editProject) {
          form.resetFields();
          setFileList([]);
          setPendingFiles([]);
          getLastProject();
        } else {
          setPendingFiles([]);
        }
      } else {
        messageApi.error(request?.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Error in onFinish:", error);
      messageApi.error("Unexpected error occurred");
    }
  };

  const handleDelete = async () => {
    try {
      const request = await ProjectService.deleteProject(id);
      if (request.status) {
        messageApi.success(request.message);
        navigate('/projects');
      } else {
        messageApi.error(request.message)
      }
    } catch (error) {
      console.error(error);
    }
  };

const getAllQotationProjects = async () => {
    try {
      const request = await QuotationService.getAllQuotation();
      setActiveQuotation(
        (request.data || []).filter((q) => q.converted_to_project === true)
      );
    } catch (error) {
      console.error(error);
    }
  };

  const getAllDirectInvoices = async () => {
    try {
      const request = await InvoiceService.getAllInvoice();
      const rows = (request?.data || []).filter(
        (inv) => (inv.source || "quotation") === "manual" && !inv.project_created
      );
      setDirectInvoices(rows);
    } catch (error) {
      console.error(error);
    }
  };

  const getAllUser = async () => {
    try {
      const request = await UserService.getAllUsers();
      setUserList(request.data);
      const active = (request.data || []).map((u) => ({
        value: u.user_id,
        label: `${u.name}${u.user_id ? ` (${u.user_id})` : ""}`,
        department_id: String(u.department_id || ""),
      }));
      setAllManagers(active);
      setManagerOption(active);
      return active;
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const getLastProject = async () => {
    try {
      const request = await ProjectService.getLastProject();
      const lastProject = request.data;
      let nextNo = "001";
      if (lastProject && lastProject.pro_no) {
        const current = parseInt(lastProject.pro_no, 10);
        if (!isNaN(current)) {
          nextNo = String(current + 1);
          if (current + 1 < 1000) nextNo = nextNo.padStart(3, "0");
        }
      }
      generateProjectId(nextNo);
    } catch (error) {
      console.error(error);
    }
  };

  const getAllDepartment = async () => {
    try {
      const request = await DepartmentEmpServices.getAllDepartment();
      const option = request.data.map((item) => ({ value: String(item.id), label: item.name }));
      setDepartmentOption(option);
    } catch (error) {
      console.error(error);
    }
  };

  const getProjectTypes = async () => {
    try {
      const request = await ConfigurationService.getByType('project_type');
      const option = (request.data || []).map((item) => ({ value: item.label, label: item.label }));
      setProjectTypeOptions(option);
    } catch (error) {
      console.error(error);
    }
  };

  const getProjectStatusOptions = async () => {
    try {
      const request = await ConfigurationService.getByType('project_status');
      const option = (request.data || []).map((item) => ({ value: item.label, label: item.label }));
      setProjectStatusOptions(option);
    } catch (error) {
      console.error(error);
    }
  };

  const getCurrencyOptions = async () => {
    try {
      const request = await ServicetypeService.getAllCurrency();
      const option = (request.data || []).map((item) => ({
        value: item.code,
        label: `${item.code} - ${item.name}`,
        id: item.id,
      }));
      setCurrencyOptions(option);
    } catch (error) {
      console.error(error);
    }
  };

  const handleAddCurrency = async () => {
    const val = newCurrency.trim();
    if (!val) return;
    if (currencyOptions.some((c) => (c.value || '').toLowerCase() === val.toLowerCase())) {
      messageApi.warning("Currency already exists");
      return;
    }
    try {
      setAddingCurrency(true);
      const request = await ServicetypeService.createCurrency({ code: val.toUpperCase(), name: val });
      if (request?.status) {
        await getCurrencyOptions();
        setNewCurrency('');
      } else {
        messageApi.error(request?.message || "Failed to add currency");
      }
    } catch (error) {
      console.error(error);
      messageApi.error("Failed to add currency");
    } finally {
      setAddingCurrency(false);
    }
  };

  const handleDeleteCurrency = async (id, value) => {
    try {
      const request = await ServicetypeService.deleteCurrency(id);
      if (request?.status) {
        setCurrencyOptions((prev) => prev.filter((c) => c.id !== id));
        if (form.getFieldValue('pro_currency') === value) {
          form.setFieldsValue({ pro_currency: undefined });
        }
      } else {
        messageApi.error(request?.message || "Failed to delete currency");
      }
    } catch (error) {
      console.error(error);
      messageApi.error("Failed to delete currency");
    }
  };

  useEffect(() => {
    getAllQotationProjects();
    getAllDirectInvoices();
    getLastProject();
    getAllDepartment();
    getAllUser();
    getProjectTypes();
    getProjectStatusOptions();
    getCurrencyOptions();
  }, []);



  const handleGetEnginer = (value, sourceList = allManagers) => {
    setSelectedDepartment(value);

    if (value) {
      const filtered = sourceList.filter((u) =>
        (u.department_id || "").split(",").some((id) => id.trim() === String(value))
      );
      setManagerOption(filtered);
      setEnginerOption(filtered);
    } else {
      setManagerOption(sourceList);
      setEnginerOption(sourceList);
    }

    form.setFieldValue('pro_manager', undefined);
    form.setFieldValue('pro_engineer', undefined);
  };

  const handleQuotationChange = (qu_no) => {
    const selected = activeQuotation.find((q) => q.qu_no === qu_no);
    if (selected) {
      form.setFieldsValue({ pro_customer: selected.customer_name || selected.customer_company });
    }
  };

  const handleDirectInvoiceChange = (invoice_no) => {
    const selected = directInvoices.find((inv) => inv.invoice_no === invoice_no);
  
    if (selected) {
      form.setFieldsValue({ pro_customer: selected.customer_contact_person || selected.customer_name });
    }
  };

  const renderItem = (eqId, customer_name, customer_company) => (
    <Flex align="center" justify="space-between" style={{ width: "100%" }}>
      <span>{eqId}</span>
      <span><UserOutlined /> {customer_name || customer_company}</span>
    </Flex>
  );

  const grouped = activeQuotation.reduce((acc, item) => {
    if (!acc[item.service_id]) {
      acc[item.service_id] = { service_name: item.service_name, items: [] };
    }
    acc[item.service_id].items.push(item);
    return acc;
  }, {});

  return (
    <>
      <style>{compactFormStyle}</style>
      {msgContext}
      <Card
        title={
          <Space align="center">
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <ArrowLeftOutlined
                style={{ cursor: "pointer", fontSize: "20px" }}
                onClick={() => navigate('/projects')}
              />
              <Title level={4} style={{ margin: 0 }}>
                <Space>
                  {editProject ? `${action} Project` : 'Add New Project'}{' '}
                  {editProject ? (
                    <Tag color="cyan" style={{ fontSize: '16px', padding: '6px 16px', borderRadius: '8px', fontWeight: 600 }}>
                      Project ID: {editProject.pro_no}
                    </Tag>
                  ) : (
                    projectId && (
                      <Tag color="blue" style={{ fontSize: '16px', padding: '6px 16px', borderRadius: '8px', fontWeight: 600 }}>
                        Project ID: {projectId}
                      </Tag>
                    )
                  )}
                </Space>
              </Title>
            </div>
          </Space>
        }
        extra={<>
          {!enableEdit && editProject && (
            <Button size="large" danger onClick={() => navigate("/projects/edit", { state: { id: id, action: 'Edit', enableEdit: true } })}>
              Enable Edit
            </Button>
          )}
        </>}
      >
        <Form layout="vertical" form={form} onFinish={onFinish} size="middle" initialValues={{ pro_source: 'Quotation', pro_currency: 'INR', pro_priority: 'Medium', pro_payment_type: 'Milestone Based', pro_allow_time_tracking: true, pro_enable_task_management: true, pro_enable_milestone_tracking: true, pro_send_email_notifications: true }}>
          <Card title={<CardTitle icon={<FileTextOutlined />} no={1} text="Project Information" />} style={{ marginBottom: 24 }}>
            <Row gutter={16}>
              <Col xs={24} sm={12} md={6}>
                <Form.Item name="pro_name" label="Project Name" rules={[{ required: true, message: 'Please enter project name' }]}>
                  <Input size="large" placeholder="Enter project name" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={6}>
                <Form.Item label="Project Code">
                  <Input size="large" readOnly value={editProject ? editProject.pro_no : projectId} placeholder="Auto-generated" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={6}>
                <Form.Item name="pro_source" label="Source">
                  <Select
                    size="large"
                    placeholder="Select source"
                    onChange={(val) => {
                      form.setFieldsValue({ qu_no: undefined });
                      if (val === "Direct Invoice") {
                        form.setFieldsValue({ pro_customer: undefined });
                      }
                    }}
                  >
                    <Option value="Quotation">Quotation</Option>
                    <Option value="Manual">Manual</Option>
                    <Option value="Direct Invoice">Direct Invoice</Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={6}>
                {source === "Direct Invoice" ? (
                  <Form.Item name="qu_no" label="Source Document No." rules={[{ required: true, message: 'Please select invoice' }]}>
                    <Select
                      showSearch
                      allowClear
                      placeholder="Select direct invoice"
                      size="large"
                      onChange={handleDirectInvoiceChange}
                      filterOption={(input, option) =>
                        (option?.searchtext || "").toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {directInvoices.map((inv) => (
                        <Option
                          key={inv.invoice_no}
                          value={inv.invoice_no}
                          searchtext={`${inv.invoice_no} ${inv.customer_contact_person || ""} ${inv.customer_name || ""}`}
                        >
                          {renderItem(inv.invoice_no, inv.customer_contact_person, inv.customer_name)}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                ) : (
                  <Form.Item name="qu_no" label="Source Document No." rules={source === 'Quotation' ? [{ required: true, message: 'Please select quotation' }] : []}>
                    <Select
                      showSearch
                      allowClear
                      disabled={source !== 'Quotation'}
                      placeholder="Select quotation"
                      size="large"
                      onChange={handleQuotationChange}
                    >
                      {Object.values(grouped).map((group) => (
                        <OptGroup key={group.service_name} label={group.service_name}>
                          {group.items.map((item) => (
                            <Option key={item.qu_no} value={item.qu_no}>
                              {renderItem(item.qu_no, item.customer_name, item.customer_company)}
                            </Option>
                          ))}
                        </OptGroup>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </Col>

              <Col xs={24} sm={12} md={6}>
       <Form.Item name="pro_type" label="Project Type (Configuration)" rules={[{ required: true, message: 'Please select project type' }]}>
                  <Select options={projectTypeOptions} size="large" showSearch allowClear placeholder="Select project type" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={6}>
                <Form.Item name="pro_customer" label="Customer / Company" rules={[{ required: true, message: 'Please enter customer' }]}>
                  <Input
                    size="large"
                    placeholder={source === "Direct Invoice" ? "Enter customer / company name" : "Select customer"}
                    disabled={source === 'Quotation'}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={6}>
                <Form.Item name="pro_value" label="Project Value (₹)" rules={[{ required: true, message: 'Please enter project value' }]}>
                  <InputNumber size="large" min={0} style={{ width: '100%' }} placeholder="Enter project value" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={6}>
                <Form.Item name="pro_currency" label="Currency">
                  <Select
                    size="large"
                    placeholder="Select currency"
                    options={currencyOptions}
                    optionRender={(option) => (
                      <Flex align="center" justify="space-between" style={{ width: "100%" }}>
                        <span>{option.data.label}</span>
                        <Popconfirm
                          title="Delete currency"
                          description="Are you sure you want to delete this currency?"
                          onConfirm={(e) => { e?.stopPropagation(); handleDeleteCurrency(option.data.id, option.data.value); }}
                          onCancel={(e) => e?.stopPropagation()}
                          okText="Yes"
                          cancelText="No"
                        >
                          <DeleteOutlined
                            style={{ color: "#ff4d4f" }}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </Popconfirm>
                      </Flex>
                    )}
                    dropdownRender={(menu) => (
                      <>
                        {menu}
                        <Divider style={{ margin: '8px 0' }} />
                        <Space style={{ padding: '0 8px 8px' }}>
                          <Input
                            placeholder="New currency"
                            value={newCurrency}
                            onChange={(e) => setNewCurrency(e.target.value)}
                            onKeyDown={(e) => e.stopPropagation()}
                            onPressEnter={handleAddCurrency}
                          />
                          <Button type="primary" loading={addingCurrency} onClick={handleAddCurrency}>
                            Add
                          </Button>
                        </Space>
                      </>
                    )}
                  />
                </Form.Item>
              </Col>
              <Col xs={24}>
                <Form.Item name="pro_description" label="Project Description / Scope">
                  <TextArea rows={3} size="large" maxLength={500} showCount placeholder="Enter project description, scope of work..." />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card title={<CardTitle icon={<CalendarOutlined />} no={2} text="Project Timeline" />} style={{ marginBottom: 24 }}>
            <Row gutter={16}>
              <Col xs={24} sm={12} md={6}>
                <Form.Item name="pro_start_date" label="Start Date" rules={[{ required: true, message: 'Please select start date' }]}>
                  <DatePicker size="large" style={{ width: "100%" }} format="DD-MM-YYYY" placeholder="Select start date" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={6}>
                <Form.Item name="pro_target_end_date" label="Expected End Date" rules={[{ required: true, message: 'Please select end date' }]}>
                  <DatePicker size="large" style={{ width: "100%" }} format="DD-MM-YYYY" placeholder="Select end date" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={6}>
                <Form.Item label="Duration">
                  <Input size="large" readOnly value={`${durationDays} Days`} />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={6}>
                <Form.Item name="pro_target_completion_date" label="Target Completion Date">
                  <DatePicker size="large" style={{ width: "100%" }} format="DD-MM-YYYY" placeholder="Select target completion date" />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Row gutter={16} style={{ marginBottom: 10 }}>
            <Col xs={24} lg={8}>
              <Card title={<CardTitle icon={<TeamOutlined />} no={3} text="Project Assignment" />} style={{ height: '100%' }}>
                <Row gutter={16}>
                  <Col xs={16}>
                    <Form.Item name="pro_department" label="Department" rules={[{ required: true, message: 'Please select department' }]}>
                      <Select size="large" allowClear optionFilterProp="label" showSearch placeholder="Select department"
                        options={departmentOption} onChange={(val) => handleGetEnginer(val)} />
                    </Form.Item>
                  </Col>

                  <Col xs={8}>
                    <Form.Item name="pro_team_size" label="Team Size">
                      <InputNumber size="large" min={0} style={{ width: '100%' }} placeholder="Enter team size" />
                    </Form.Item>
                  </Col>

                  <Col xs={24}>
                    <Form.Item name="pro_manager" label="Project Manager" rules={[{ required: true, message: 'Please select project manager' }]}>
                      <Select options={managerOption} size="large" showSearch allowClear
                        disabled={!selectedDepartment}
                        placeholder={selectedDepartment ? "Select project manager" : "Select project manager"}
                        filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())} />
                    </Form.Item>
                  </Col>

                  <Col xs={24}>
                    <Form.Item name="pro_engineer" label="Engineer">
                      <Select size="large" mode="multiple" allowClear showSearch optionFilterProp="label"
                        options={engineerOption} placeholder="Select engineers" disabled={!selectedDepartment} />
                    </Form.Item>
                  </Col>

                  <Col xs={24}>
                    <Form.Item name="pro_priority" label="Priority" rules={[{ required: true, message: 'Please select priority' }]}>
                      <Select options={priorityOptions} size="large" allowClear placeholder="Select priority" />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>

            <Col xs={24} lg={8}>
              <Card title={<CardTitle icon={<WalletOutlined />} no={4} text="Project Budget & Payment" />} style={{ height: '100%' }}>
                <Row gutter={16}>
                  <Col xs={12}>
                    <Form.Item name="pro_payment_type" label="Payment Type" rules={[{ required: true, message: 'Please select payment type' }]}>
                      <Select options={paymentTypeOptions} size="large" placeholder="Select payment type" />
                    </Form.Item>
                  </Col>

                  <Col xs={12}>
                    <Form.Item name="pro_total_budget" label="Total Budget (₹)">
                      <InputNumber size="large" min={0} style={{ width: '100%' }} placeholder="0.00" />
                    </Form.Item>
                  </Col>

                  <Col xs={12}>
                    <Form.Item name="pro_down_payment_percent" label="Down Payment (%)">
                      <InputNumber size="large" min={0} max={100} style={{ width: '100%' }} placeholder="0" />
                    </Form.Item>
                  </Col>

                  <Col xs={12}>
                    <Form.Item name="pro_down_payment_amount" label="Down Payment Amount (₹)">
                      <InputNumber size="large" readOnly style={{ width: '100%' }} placeholder="0.00" />
                    </Form.Item>
                  </Col>

                  <Col xs={24}>
                    <Form.Item name="pro_payment_terms" label="Payment Terms">
                      <TextArea rows={3} size="large" maxLength={300} showCount placeholder="Enter payment terms and conditions..." />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>

            <Col xs={24} lg={8}>
              <Card title={<CardTitle icon={<SettingOutlined />} no={5} text="Project Status & Settings" />} style={{ height: '100%' }}>
                <Row gutter={16}>
                  <Col xs={12}>
                    <Form.Item name="pro_status" label="Initial Status" rules={[{ required: true, message: 'Please select status' }]}>
                      <Select options={statusOptions} size="large" placeholder="Select status" />
                    </Form.Item>
                  </Col>


                  {/* <Col xs={12}>
                    <Form.Item name="pro_visibility" label="Visibility">
                      <Select options={visibilityOptions} size="large" placeholder="Select visibility" />
                    </Form.Item>
                  </Col> */}

                  <Col xs={12}>
           <Form.Item name="pro_visibility" label="Project Status (Configuration)">
                      <Select options={projectStatusOptions} size="large" showSearch allowClear placeholder="Select project status" />
                    </Form.Item>
                  </Col>

                  <Col xs={24}>
                    <Form.Item name="pro_allow_time_tracking" label="Allow Time Tracking" valuePropName="checked">
                      <Switch />
                    </Form.Item>
                  </Col>

                  <Col xs={24}>
                    <Form.Item name="pro_enable_task_management" label="Enable Task Management" valuePropName="checked">
                      <Switch />
                    </Form.Item>
                  </Col>

                  <Col xs={24}>
                    <Form.Item name="pro_enable_milestone_tracking" label="Enable Milestone Tracking" valuePropName="checked">
                      <Switch />
                    </Form.Item>
                  </Col>

                  <Col xs={24}>
                    <Form.Item name="pro_send_email_notifications" label="Send Email Notifications" valuePropName="checked">
                      <Switch />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>

          <Card title={<CardTitle icon={<PaperClipOutlined />} no={6} text="Additional Information" />} style={{ marginBottom: 24 }}>
            <Row gutter={16}>
              <Col xs={24} md={8}>
                <Form.Item name="pro_tags" label="Tags / Keywords">
                  <Select mode="tags" size="large" placeholder="Enter tags and press enter" open={false} suffixIcon={null} />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item label="Attachments">
                  <Upload.Dragger
                    fileList={[...fileList, ...pendingFiles]}
                    multiple
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
                    beforeUpload={(file) => {
                      setPendingFiles((prev) => [
                        ...prev,
                        {
                          uid: `pending-${Date.now()}-${file.name}`,
                          name: file.name,
                          status: "done",
                          originFileObj: file,
                          __pending: true,
                        },
                      ]);
                      return false;
                    }}
                    onRemove={(file) => {
                      if (file.__pending) {
                        setPendingFiles((prev) => prev.filter((f) => f.uid !== file.uid));
                      } else {
                        setFileList((prev) => prev.filter((f) => f.uid !== file.uid));
                      }
                    }}
                  >
                    <p className="ant-upload-drag-icon"><InboxOutlined /></p>
                    <p className="ant-upload-text">Drag & drop files here or click to upload</p>
                    <p className="ant-upload-hint"></p>
                  </Upload.Dragger>
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item name="pro_comment" label="Notes">
                  <TextArea rows={5} size="large" maxLength={300} showCount placeholder="Enter any additional notes..." />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Divider />
          <div style={{ display: 'flex', justifyContent: 'right' }}>
            <Space>
              <Button size='large' onClick={() => navigate('/projects')}>Cancel</Button>

              {editProject && (
                <Button size="large" danger onClick={handleDelete}>Delete Project</Button>
              )}

              <Button
                type="primary"
                size="large"
                htmlType="submit"
                style={{ backgroundColor: "rgba(14, 93, 146, 0.95)", borderColor: "rgba(14, 93, 146, 0.95)" }}
              >
                {editProject ? "Update Project" : "Save Project"}
              </Button>
            </Space>
          </div>
        </Form>
      </Card>
    </>
  );
};

export default CreateProjects;